const initialState = {
    reconRefId: null,
    sourceRefId: null,
    dashboardType: null,
    uiFieldObject: null,
    query: null,
    is_disable_audit: false,
    is_disable_versions: false,
};

export default initialState;